import * as React from "react";
import type { SVGProps } from "react";

interface TwoMinuteWarningProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const TwoMinuteWarning = ({ cancelled = false, ...props }: TwoMinuteWarningProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(.5)">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M7.62 0c.68 0 1.25.51 1.34 1.24v.13c0 .3-.1.58-.27.8l-.06.08.16.05a6.65 6.65 0 0 1 4.58 6.07v.24c0 3.67-2.99 6.64-6.68 6.64A6.67 6.67 0 0 1 0 8.61 6.65 6.65 0 0 1 4.58 2.3l.17-.05-.06-.07q-.225-.3-.27-.69v-.15C4.42.6 5.02 0 5.76 0zm0 .75H5.76a.6.6 0 0 0-.59.5v.12c0 .32.26.59.59.59h.47v.77A5.91 5.91 0 0 0 .75 8.61c0 3.25 2.66 5.89 5.94 5.89h.22a5.91 5.91 0 0 0 5.71-5.9c0-3.1-2.41-5.64-5.48-5.87v-.77h.58a.6.6 0 0 0 .49-.6v-.09a.6.6 0 0 0-.6-.52Z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M7.62.65a.7.7 0 0 1 .69.62v.1a.7.7 0 0 1-.7.69h-.37v.58l.14.01a6.01 6.01 0 0 1 5.34 5.73v.23c0 3.3-2.7 5.99-6.03 5.99a6.02 6.02 0 0 1-6.04-6A6.01 6.01 0 0 1 6 2.66l.13-.01v-.58h-.37a.7.7 0 0 1-.69-.6v-.12c0-.38.3-.69.69-.69h1.86Z"
        />
        <ellipse cx={6.65} cy={8.59} fill="#FFF" rx={5.05} ry={5.09} />
      </g>
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M7.19 4.68a.52.52 0 0 0-.52.51v3.06c0 .29.23.52.52.52h3.75c.29 0 .52-.23.52-.52v-.07a.52.52 0 0 0-.52-.45H7.66L7.7 5.2a.52.52 0 0 0-.52-.51Z"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M15.69 8.38a7.75 7.75 0 1 0 0 15.5 7.75 7.75 0 0 0 0-15.5"
      />
      <path
        fill="#007BBD"
        fillRule="nonzero"
        d="M15.69 9.13a7 7 0 1 1 0 14 7 7 0 0 1 0-14"
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M14.07 20.63c-.51 0-.77-.15-.77-.43 0-.63.16-1.23.49-1.82.32-.6.87-1.25 1.63-1.98.27-.26.52-.52.77-.79q.36-.39.6-.78c.15-.25.23-.5.24-.73.01-.45-.1-.79-.3-1q-.33-.33-.9-.33c-.54 0-.87.27-1.02.8-.07.24-.16.42-.27.55-.1.12-.27.19-.5.19a.66.66 0 0 1-.52-.22c-.13-.15-.16-.35-.1-.6q.21-.96.84-1.5.645-.54 1.56-.54.75 0 1.35.3c.4.22.7.52.93.92.22.4.33.89.31 1.47 0 .4-.1.78-.29 1.13-.18.35-.42.68-.72 1-.3.33-.64.68-1.02 1.04-.4.39-.75.76-1.06 1.12-.3.35-.48.66-.54.92h2.7c.52 0 .77.21.77.64 0 .42-.25.64-.76.64z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default TwoMinuteWarning;
